import { getNameByProductRoute } from '../ProductBreadcrumbs/utils/create-category-breadcrumb.js';

function createProductTypeBreadcrumb(pageRoutes, path = '', transformUrl) {
    const { name , url  } = findProductTypeUrl(pageRoutes, path);
    return {
        name: name || '',
        url: url && transformUrl ? transformUrl(url) : url
    };
}
function findProductTypeUrl(pageRoutes, path) {
    // Inverse pageRoutes so we can access it by path instead of name
    const routesByPath = Object.entries(pageRoutes).reduce((acc, [key, value])=>{
        acc[value] = key;
        return acc;
    }, {});
    // Retrieve combined path segments and check if it exists in the pageRoutes
    const routes = getRouteSegmentsByPath(path);
    const productTypePath = routes.find((route)=>route in routesByPath
    );
    return productTypePath ? {
        url: productTypePath,
        name: routesByPath[productTypePath]
    } : {};
}
/**
 * Returns all possible combined path segments from a given path
 * For a path `/contact-lenses/solutions/branding` we would like to have all possible combined sections:
 *    `/contact-lenses/solutions/branding`
 *    `/contact-lenses/solutions`
 *    `/contact-lenses`
 */ function getRouteSegmentsByPath(path) {
    return path.split('/').slice(1).reduce((prev, curr, index)=>{
        // append the current path section to the previous section
        const newPathSection = prev[index].concat(`/${curr}`);
        prev.push(newPathSection);
        return prev;
    }, [
        ''
    ]).slice(1).reverse();
}
const getProductTypeName = (breadcrumb, getLabel, page)=>{
    var ref;
    const productTypeName = page && breadcrumb.url && getNameByProductRoute(breadcrumb.url, page);
    return productTypeName ? productTypeName : getLabel(`products.${(ref = breadcrumb.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()}`, {
        defaultValue: breadcrumb.name
    });
};
const capitalizeWords = (str)=>str.replace(/\b\w/g, (char)=>char.toUpperCase()
    )
;

export { capitalizeWords, createProductTypeBreadcrumb, findProductTypeUrl, getProductTypeName, getRouteSegmentsByPath };
//# sourceMappingURL=utils.js.map
